const { generate: genId } = require("shortid");
const {
	assignIdsToHeaders,
	transformLinkGroup,
} = require("../../utils/prismic-data-utils");

module.exports.transformHomePageData = data =>
	data.prismic.allReapredistHomePages.edges.map(({ node }) => ({
		...node,
		historyHeading: assignIdsToHeaders(node.historyHeading),
		historyText: assignIdsToHeaders(node.historyText),
		backgroundHeading: assignIdsToHeaders(node.backgroundHeading),
		backgroundText: assignIdsToHeaders(node.backgroundText),
		statusHeading: assignIdsToHeaders(node.statusHeading),
		statusText: assignIdsToHeaders(node.statusText),
		timelineHeading: assignIdsToHeaders(node.timelineHeading),
		additionalInformationGroups: node.body.map(transformLinkGroup),
		timelineItems: node.timelineItem
			.filter(item => item.date && item.description)
			.map(item => ({
				icon: item.category,
				date: item.date ? `${item.date}T00:00:00-08:00` : null,
				description: assignIdsToHeaders(item.description),
				plainTextDescription: item.description
					.map(d => d.text)
					.join(" "),
				url: item.link == null ? null : item.link.url,
				id: genId(),
			})),
	}))[0];
